import React from "react";
import { Link, useParams } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function OrderConfirmationPage() {
  const { ref } = useParams();
  const { t } = useLanguage();
  return (
    <main className="min-h-screen bg-[#F6F2EC] text-[#252525] pt-28 pb-24 flex items-center" data-testid="order-confirmation">
      <div className="container-tessa max-w-2xl text-center">
        <span className="grid place-items-center h-16 w-16 rounded-full bg-[#C4A46B] text-black mx-auto mb-8">
          <Check size={32} />
        </span>
        <span className="font-sans text-xs uppercase tracking-[0.24em] text-[#D92A47]">{t("form.successTitle")}</span>
        <h1 className="font-serif text-5xl md:text-6xl leading-[0.95] text-[#252525] mt-4">{t("pages.confirmation.title")}</h1>
        <p className="text-[#817B74] mt-5 leading-relaxed">
          {t("pages.confirmation.text")}
        </p>
        <div className="mt-8 inline-block border border-black/10 bg-white px-6 py-4">
          <div className="text-[11px] uppercase tracking-[0.16em] text-[#817B74]">{t("pages.confirmation.reference")}</div>
          <div className="font-serif text-2xl text-[#252525]" data-testid="confirmation-reference">{ref}</div>
        </div>
        <div className="mt-10">
          <Link to="/" className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.14em] text-[#D92A47] border-b border-[#D92A47] pb-1">
            <ArrowLeft size={14} /> {t("pages.backHome")}
          </Link>
        </div>
      </div>
    </main>
  );
}
